/* ============================================================
   CELER · PDP v1 — assets/celer-pdp-v1.js
   ============================================================
   Adaptado de celer-pdp1-v8.html. Cambios vs el v8 estatico:
     - Selectores con prefijo .cpdp-* y IDs #cpdp* para no colisionar.
     - initColorSelector eliminado: en la PDP Liquid cada color es un
       producto separado, los thumbs son <a href> y el navegador navega.
       Se sustituye por initColorPrefetch que precarga el HTML del
       producto hermano al hover para que la navegacion sea instantanea.
     - Stock badge ya no se actualiza en cliente (Liquid lo renderiza
       server-side por producto). Se elimina updateStockBadge.
     - Anadido initAtc: form submit interceptado -> fetch /cart/add.js
       -> handleAtc visual feedback -> window.celerOpenCartDrawer().
       Si no existe celerOpenCartDrawer (drawer no montado), fallback
       a navegar /cart.
     - El boton emocional mantiene el patron 2-clicks del v8: primer
       click ATC, segundo click abre drawer.
   ============================================================ */

(function() {
  'use strict';

  /* La galeria expone aqui su navegacion para que el selector de variante
     pueda saltar a la foto de la variante elegida. goToSlide vive dentro de
     initGallery y de otro modo no es alcanzable. Queda null en fichas sin
     galeria, y todo uso va guardado. */
  var galleryGoTo = null;

  /* ------------------------------------------------------------
     1. GALERIA
     ------------------------------------------------------------ */
  function initGallery() {
    const track = document.getElementById('cpdpGalleryTrack');
    if (!track) return;
    const dots = document.querySelectorAll('#cpdpGalleryDots .cpdp-gallery__dot');
    const thumbs = document.querySelectorAll('#cpdpGalleryThumbs .cpdp-gallery-thumb');
    const prev = document.querySelector('.cpdp-gallery__arrow--prev');
    const next = document.querySelector('.cpdp-gallery__arrow--next');

    const slideCount = Math.max(dots.length, thumbs.length, 1);
    let currentIdx = 0;

    function setActive(idx) {
      currentIdx = idx;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      /* Regla de agencia: en la primera foto solo se ve la flecha derecha;
         en la ultima, solo la izquierda. Mostrar/ocultar, NO gris. */
      if (prev) prev.hidden = idx <= 0;
      if (next) next.hidden = idx >= slideCount - 1;
    }

    function goToSlide(idx) {
      const clamped = Math.max(0, Math.min(slideCount - 1, idx));
      track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
      setActive(clamped);
    }

    track.addEventListener('scroll', function() {
      requestAnimationFrame(function() {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== currentIdx) setActive(idx);
      });
    }, { passive: true });

    dots.forEach((d, i) => d.addEventListener('click', () => goToSlide(i)));
    thumbs.forEach((t, i) => t.addEventListener('click', () => goToSlide(i)));
    if (prev) prev.addEventListener('click', () => goToSlide(currentIdx - 1));
    if (next) next.addEventListener('click', () => goToSlide(currentIdx + 1));

    galleryGoTo = goToSlide;

    /* Arranque: si se llega con ?variant=X y esa variante tiene foto propia,
       abrir ahi. Sin scroll suave, que en la carga se ve como un tiron.

       MEDIDO: calcularlo como startIdx * track.clientWidth NO funciona en la
       carga — en ese instante clientWidth todavia es 0 (las fotos no han
       resuelto el layout), asi que 9*0 = 0: el punto marcaba la 9 y se veia
       la 1. Se usa el offsetLeft REAL de la diapositiva, y se reintenta en
       el siguiente frame y en 'load' por si aun no estaba maquetada.
       Si el usuario ya ha movido la galeria, no se le da el tiron. */
    var gal = document.getElementById('cpdpGallery');
    var startIdx = gal ? parseInt(gal.getAttribute('data-cpdp-start-media') || '0', 10) : 0;
    if (!(startIdx >= 0 && startIdx < slideCount)) startIdx = 0;

    function applyStartIdx() {
      if (startIdx <= 0) return;
      if (track.scrollLeft > 0) return;           // ya hay posicion: no tocar
      var el = track.children[startIdx], first = track.children[0];
      if (!el || !first) return;
      var left = el.offsetLeft - first.offsetLeft;
      if (left > 0) {
        track.scrollLeft = left;
        setActive(startIdx);
      }
    }

    setActive(startIdx);
    applyStartIdx();
    requestAnimationFrame(applyStartIdx);
    window.addEventListener('load', applyStartIdx, { once: true });
    initZoom(track, () => currentIdx, goToSlide, slideCount);
  }

  /* ------------------------------------------------------------
     2b. ZOOM / LIGHTBOX  (no existia en ninguna PDP)
     En ropa tecnica el tejido es el argumento de venta: sin poder
     ampliar, no se puede verificar.
     ------------------------------------------------------------ */
  function initZoom(track, getIdx, goToSlide, slideCount) {
    if (document.getElementById('cpdpZoom')) return;
    const imgs = Array.prototype.slice.call(track.querySelectorAll('img'));
    if (!imgs.length) return;

    const box = document.createElement('div');
    box.id = 'cpdpZoom';
    box.className = 'cpdp-zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Foto ampliada');
    box.hidden = true;
    box.innerHTML =
      '<button type="button" class="cpdp-zoom__close" aria-label="Cerrar">&times;</button>' +
      '<button type="button" class="cpdp-zoom__nav cpdp-zoom__nav--prev" aria-label="Anterior">&larr;</button>' +
      '<img class="cpdp-zoom__img" alt="">' +
      '<button type="button" class="cpdp-zoom__nav cpdp-zoom__nav--next" aria-label="Siguiente">&rarr;</button>';
    document.body.appendChild(box);

    const zImg = box.querySelector('.cpdp-zoom__img');
    const zPrev = box.querySelector('.cpdp-zoom__nav--prev');
    const zNext = box.querySelector('.cpdp-zoom__nav--next');
    let zIdx = 0;
    let lastFocus = null;

    function paint(i) {
      zIdx = Math.max(0, Math.min(imgs.length - 1, i));
      const src = imgs[zIdx].currentSrc || imgs[zIdx].src;
      zImg.src = src.replace(/([?&])width=\d+/, '$1width=1800');
      zImg.alt = imgs[zIdx].alt || '';
      zPrev.hidden = zIdx <= 0;
      zNext.hidden = zIdx >= imgs.length - 1;
    }
    function open(i) {
      lastFocus = document.activeElement;
      paint(i);
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      box.querySelector('.cpdp-zoom__close').focus();
    }
    function close() {
      box.hidden = true;
      document.body.style.overflow = '';
      /* devolver la galeria a la foto que se estaba viendo ampliada */
      if (typeof goToSlide === 'function' && zIdx !== getIdx()) goToSlide(zIdx);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    imgs.forEach((im, i) => {
      im.style.cursor = 'zoom-in';
      im.addEventListener('click', () => open(i));
    });
    box.querySelector('.cpdp-zoom__close').addEventListener('click', close);
    zPrev.addEventListener('click', () => paint(zIdx - 1));
    zNext.addEventListener('click', () => paint(zIdx + 1));
    box.addEventListener('click', (e) => { if (e.target === box) close(); });
    document.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') paint(zIdx - 1);
      if (e.key === 'ArrowRight') paint(zIdx + 1);
    });
  }

  /* ------------------------------------------------------------
     3. COLOR PREFETCH (los thumbs son links a productos hermanos)
     ------------------------------------------------------------ */
  function initColorPrefetch() {
    const thumbs = document.querySelectorAll('[data-cpdp-prefetch]');
    const prefetched = {};
    thumbs.forEach(function(a) {
      a.addEventListener('mouseenter', function() {
        const href = a.getAttribute('href');
        if (!href || prefetched[href]) return;
        prefetched[href] = true;
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = href;
        document.head.appendChild(link);
      }, { passive: true });
    });
  }

  /* ------------------------------------------------------------
     4. ACCORDION
     ------------------------------------------------------------ */
  function initAccordion() {
    const items = document.querySelectorAll('.cpdp-accordion__item');
    items.forEach(function(item) {
      if (item.classList.contains('is-open')) {
        const content = item.querySelector('.cpdp-accordion__content');
        if (content) {
          requestAnimationFrame(function() {
            content.style.maxHeight = content.scrollHeight + 'px';
          });
        }
      }
    });
    items.forEach(function(item) {
      const trigger = item.querySelector('.cpdp-accordion__trigger');
      const content = item.querySelector('.cpdp-accordion__content');
      if (!trigger || !content) return;
      trigger.addEventListener('click', function() {
        const isOpen = item.classList.contains('is-open');
        if (isOpen) {
          content.style.maxHeight = '0px';
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
    window.addEventListener('resize', function() {
      items.forEach(function(item) {
        if (item.classList.contains('is-open')) {
          const content = item.querySelector('.cpdp-accordion__content');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  /* ------------------------------------------------------------
     5. FADE-IN AL SCROLL (bloque emocional)
     ------------------------------------------------------------ */
  function initFadeIn() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.cpdp-emo__photo, .cpdp-emo__text').forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }
    const targets = document.querySelectorAll('.cpdp-emo__photo, .cpdp-emo__text');
    const obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(function(t) { obs.observe(t); });
  }

  /* ------------------------------------------------------------
     6. STICKY BOTTOM CTA visibility (mobile only)
     ------------------------------------------------------------
     Simple scroll listener: el sticky aparece cuando hemos scroleado
     mas alla del bottom del .cpdp-product-info. IntersectionObserver
     fallaba con productInfo sticky (boundingClientRect raro).
  */
  function initStickyVisibility() {
    const sticky = document.getElementById('cpdpStickyCta');
    const productInfo = document.getElementById('cpdpProductInfo');
    if (!sticky || !productInfo) return;

    const mq = window.matchMedia('(max-width: 1023px)');
    let triggerY = 0;
    /* Ficha v2: la columna lleva debajo cross-sell y acordeones, asi que
       la barra aparece al dejar atras el BOTON, no la columna entera. */
    const triggerEl = document.querySelector('[data-cpdp-sticky-trigger]') || productInfo;

    function recalcTrigger() {
      const rect = triggerEl.getBoundingClientRect();
      triggerY = rect.bottom + window.scrollY;
    }

    /* El footer no puede quedar tapado por la barra: al llegar a el, la
       barra se retira. Se mide contra el footer REAL de la pagina. */
    const footerEl = document.querySelector('footer, .cf, #shopify-section-footer, [class*="celer-footer"]');
    function footerVisible() {
      if (!footerEl) return false;
      const r = footerEl.getBoundingClientRect();
      return r.top < window.innerHeight - 8;
    }

    function onScroll() {
      if (!mq.matches) {
        if (sticky.classList.contains('is-visible')) {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
        return;
      }
      const shouldShow = window.scrollY > triggerY && !footerVisible();
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    recalcTrigger();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() {
      recalcTrigger();
      onScroll();
    }, { passive: true });
    window.addEventListener('orientationchange', function() {
      setTimeout(function() { recalcTrigger(); onScroll(); }, 100);
    }, { passive: true });
    window.addEventListener('load', function() { recalcTrigger(); onScroll(); });
    setTimeout(function() { recalcTrigger(); onScroll(); }, 1500);
    setTimeout(function() { recalcTrigger(); onScroll(); }, 3000);
    onScroll();
  }

  /* ------------------------------------------------------------
     7. ATC core: fetch + cart drawer
     ------------------------------------------------------------ */
  function showToast(text, isError) {
    const toast = document.getElementById('cpdpToast');
    if (!toast) return;
    toast.textContent = text;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-visible');
    setTimeout(function() { toast.classList.remove('is-visible'); }, 2200);
  }

  function openCartDrawer() {
    if (typeof window.celerOpenCartDrawer === 'function') {
      try { window.celerOpenCartDrawer(); return true; } catch (err) {
        console.warn('[cpdp] celerOpenCartDrawer threw', err);
      }
    }
    return false;
  }

  function addToCart(form) {
    const fd = new FormData(form);
    const sectionsToRender = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(c) {
      if (c.dataset.sectionId) sectionsToRender.push(c.dataset.sectionId);
    });
    if (sectionsToRender.length > 0) fd.append('sections', sectionsToRender.join(','));
    fd.append('sections_url', window.location.pathname);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function(r) {
      if (!r.ok) {
        return r.json().then(function(err) { throw err; });
      }
      return r.json();
    });
  }

  function dispatchCartUpdate(data) {
    if (data && data.sections) {
      try {
        Object.keys(data.sections).forEach(function(sectionId) {
          var newHtml = data.sections[sectionId];
          if (!newHtml) return;
          var tempDoc = new DOMParser().parseFromString(newHtml, 'text/html');
          var newCic = tempDoc.querySelector('cart-items-component[data-section-id="' + sectionId + '"]')
                    || tempDoc.querySelector('cart-items-component');
          var oldCic = document.querySelector('cart-items-component[data-section-id="' + sectionId + '"]')
                    || document.querySelector('cart-items-component');
          if (newCic && oldCic) {
            oldCic.innerHTML = newCic.innerHTML;
          }
        });
      } catch (err) {
        console.warn('[cpdp] morph cart-items-component failed', err);
      }
    }
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { source: 'celer-pdp-v1', data: data || null }
      }));
    } catch (err) {}
  }

  function visualConfirm(button, doneText, revertAfterMs) {
    if (!button) return;
    /* Escribir en el BOTON borraria el <span id="cpdpBuyText">, y a partir
       de ahi el selector de variante ya no podria cambiar el rotulo (p.ej.
       dejaria "ANADIR AL CARRITO" al pasar a una variante agotada).
       Se escribe en el span cuando existe. */
    const label = button.querySelector('#cpdpBuyText') || button;
    const originalText = label.textContent;
    button.classList.add('is-added');
    label.textContent = doneText || '✓ AÑADIDO';
    if (revertAfterMs) {
      setTimeout(function() {
        button.classList.remove('is-added');
        label.textContent = originalText;
      }, revertAfterMs);
    }
  }

  /* ------------------------------------------------------------
     8. ATC handlers (form submit + sticky button + emocional)
     ------------------------------------------------------------ */
  function initAtc() {
    const form = document.getElementById('cpdpAtcForm');
    const stickyBuy = document.getElementById('cpdpStickyBuy');
    const emoCta = document.getElementById('cpdpEmoCta');

    if (form) {
      form.addEventListener('submit', function(e) {
        const submitter = e.submitter;
        if (!submitter || submitter.dataset.cpdpAtc === undefined) return;
        e.preventDefault();
        submitter.disabled = true;
        addToCart(form).then(function(data) {
          visualConfirm(submitter, submitter.dataset.cpdpAfter || '✓ AÑADIDO AL CARRITO', 2500);
          showToast('✓ AÑADIDO AL CARRITO');
          dispatchCartUpdate(data);
          setTimeout(function() {
            const opened = openCartDrawer();
            if (!opened) {
              window.location.href = '/cart';
            }
          }, 250);
        }).catch(function(err) {
          console.error('[cpdp] ATC error', err);
          showToast('ERROR · INTENTA DE NUEVO', true);
        }).finally(function() {
          setTimeout(function() { submitter.disabled = false; }, 2500);
        });
      });
    }

    if (stickyBuy) {
      stickyBuy.addEventListener('click', function() {
        if (stickyBuy.disabled) return;

        /* Si el producto tiene tallas y el usuario NO ha elegido ninguna,
           el sticky NO compra a ciegas la primera disponible: lleva al
           selector y lo resalta. Comprar una talla que nadie eligio es
           una devolucion casi asegurada. */
        var picker = document.getElementById('cpdpSizeSelector')
          || document.querySelector('[data-cpdp-size-selector], .cpdp-size-selector');
        var rootEl = document.querySelector('.cpdp-root');
        var chosen = rootEl && rootEl.getAttribute('data-cpdp-size-chosen') === 'true';
        if (picker && !chosen) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          picker.classList.add('cpdp-needs-pick');
          setTimeout(function () { picker.classList.remove('cpdp-needs-pick'); }, 1800);
          var first = picker.querySelector('button:not([aria-disabled="true"])');
          if (first && first.focus) first.focus();
          showToast('ELIGE TU TALLA');
          return;
        }

        stickyBuy.disabled = true;
        const fakeForm = form || buildFallbackForm();
        addToCart(fakeForm).then(function(data) {
          visualConfirm(stickyBuy, '✓ AÑADIDO', 2500);
          showToast('✓ AÑADIDO AL CARRITO');
          dispatchCartUpdate(data);
          setTimeout(function() {
            const opened = openCartDrawer();
            if (!opened) window.location.href = '/cart';
          }, 250);
        }).catch(function(err) {
          console.error('[cpdp] sticky ATC error', err);
          showToast('ERROR · INTENTA DE NUEVO', true);
        }).finally(function() {
          setTimeout(function() { stickyBuy.disabled = false; }, 2500);
        });
      });
    }

    if (emoCta) {
      let added = false;
      let originalText = emoCta.textContent;
      emoCta.addEventListener('click', function() {
        if (added) {
          openCartDrawer();
          return;
        }
        if (emoCta.disabled) return;
        emoCta.disabled = true;
        const fakeForm = form || buildFallbackForm();
        addToCart(fakeForm).then(function(data) {
          added = true;
          emoCta.classList.add('is-added');
          emoCta.textContent = '✓ AÑADIDO · VER CARRITO →';
          showToast('✓ AÑADIDO AL CARRITO');
          dispatchCartUpdate(data);
          emoCta.disabled = false;
          setTimeout(function() {
            added = false;
            emoCta.classList.remove('is-added');
            emoCta.textContent = originalText;
          }, 5000);
        }).catch(function(err) {
          console.error('[cpdp] emo ATC error', err);
          showToast('ERROR · INTENTA DE NUEVO', true);
          emoCta.disabled = false;
        });
      });
    }
  }

  function buildFallbackForm() {
    if (window._cpdpFallbackForm) return window._cpdpFallbackForm;
    const f = document.createElement('form');
    const root = document.querySelector('.cpdp-root');
    const variantId = root && root.dataset.cpdpVariantId;
    if (!variantId) return f;
    const id = document.createElement('input');
    id.name = 'id';
    id.value = variantId;
    f.appendChild(id);
    const qty = document.createElement('input');
    qty.name = 'quantity';
    qty.value = '1';
    f.appendChild(qty);
    window._cpdpFallbackForm = f;
    return f;
  }

  /* ------------------------------------------------------------
     9. CROSS-SELL "COMPLETA TU EQUIPO" — + AÑADIR directo al carrito
     ------------------------------------------------------------
     Reutiliza addToCart() + dispatchCartUpdate() + openCartDrawer().
     Cada boton lleva data-variant-id del producto sugerido (monovariante).
     Al exito: abre el cart drawer (mismo patron que el ATC principal). */
  function initXsellAdd() {
    const buttons = document.querySelectorAll('[data-cpdp-xsell-add]');
    if (!buttons.length) return;
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        const originalText = btn.textContent;
        const f = document.createElement('form');
        const idInput = document.createElement('input');
        idInput.name = 'id';
        idInput.value = variantId;
        f.appendChild(idInput);
        const qtyInput = document.createElement('input');
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        f.appendChild(qtyInput);
        addToCart(f).then(function(data) {
          btn.classList.add('is-added');
          btn.textContent = '✓ AÑADIDO';
          showToast('✓ AÑADIDO AL CARRITO');
          dispatchCartUpdate(data);
          setTimeout(function() {
            const opened = openCartDrawer();
            if (!opened) window.location.href = '/cart';
          }, 250);
          setTimeout(function() {
            btn.classList.remove('is-added');
            btn.textContent = originalText;
          }, 2500);
        }).catch(function(err) {
          console.error('[cpdp] xsell ATC error', err);
          showToast('ERROR · INTENTA DE NUEVO', true);
        }).finally(function() {
          setTimeout(function() { btn.disabled = false; }, 2500);
        });
      });
    });
  }

  /* ------------------------------------------------------------
     10. CARRUSELES MOVIL con dots sincronizados (resenas + xsell)
     ------------------------------------------------------------
     Reutiliza el patron de initGallery: listener de scroll que calcula
     el indice activo por scrollLeft/stride y sincroniza los dots.
     Solo opera en movil (<1024px). Los dots se generan en runtime. */
  function initMobileCarousel(trackSel, dotsSel) {
    const track = document.querySelector(trackSel);
    const dotsWrap = document.querySelector(dotsSel);
    if (!track || !dotsWrap) return;
    const items = track.children;
    const count = items.length;
    if (count <= 1) { dotsWrap.style.display = 'none'; return; }
    dotsWrap.innerHTML = '';
    for (let i = 0; i < count; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'cpdp-carousel-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Item ' + (i + 1));
      b.dataset.index = i;
      dotsWrap.appendChild(b);
    }
    const dots = dotsWrap.querySelectorAll('.cpdp-carousel-dot');
    let currentIdx = 0;
    function setActive(idx) {
      currentIdx = idx;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }
    function itemStride() {
      if (count < 2) return track.clientWidth;
      return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
    }
    track.addEventListener('scroll', function() {
      requestAnimationFrame(function() {
        const stride = itemStride() || track.clientWidth;
        const idx = Math.round(track.scrollLeft / stride);
        const clamped = Math.max(0, Math.min(count - 1, idx));
        if (clamped !== currentIdx) setActive(clamped);
      });
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', function() {
      const stride = itemStride() || track.clientWidth;
      track.scrollTo({ left: i * stride, behavior: 'smooth' });
      setActive(i);
    }));
  }

  function initCarousels() {
    const mq = window.matchMedia('(max-width: 1023px)');
    if (!mq.matches) return;
    initMobileCarousel('.cpdp-reviews__grid', '.cpdp-reviews__dots');
    initMobileCarousel('.cpdp-suggested__grid', '.cpdp-suggested__dots');
  }

  /* ------------------------------------------------------------
     Boot
     ------------------------------------------------------------ */
  /* Selector de variante. Copiado literal de celer-pdp-tee-v1.js: es
     generico (se engancha a .cpdp-size-option) y todos sus accesos van
     guardados con if, asi que en una ficha sin selector no hace nada. */
  function initSizeSelector() {
    var options = document.querySelectorAll('.cpdp-size-option');
    if (!options.length) return;

    var sizeLabel = document.getElementById('cpdpSizeLabel');
    var variantInput = document.getElementById('cpdpVariantInput');
    var buyText = document.getElementById('cpdpBuyText');
    var buyBtn = document.getElementById('cpdpMainBuy');
    var stockMobile = document.getElementById('cpdpStockBadgeMobile');
    var stockDesktop = document.getElementById('cpdpStockBadgeDesktop');
    var stickyPrice = document.getElementById('cpdpStickyPrice');
    var root = document.querySelector('.cpdp-root');

    var THRESHOLD = 20; // sincronizado con el schema default
    if (root && root.hasAttribute('data-cpdp-threshold')) {
      var thr = parseInt(root.getAttribute('data-cpdp-threshold'), 10);
      if (!isNaN(thr)) THRESHOLD = thr;
    }
    var buyPrice = document.getElementById('cpdpBuyPrice');
    var comparePrice = document.getElementById('cpdpComparePrice');
    var avail = document.getElementById('cpdpAvail');

    options.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.getAttribute('aria-disabled') === 'true') return;

        options.forEach(function(o) {
          o.classList.remove('is-active');
          if (o.hasAttribute('aria-pressed')) o.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', 'true');

        var vid = btn.getAttribute('data-cpdp-variant-id');
        var vtitle = btn.getAttribute('data-cpdp-variant-title');
        var vprice = btn.getAttribute('data-cpdp-variant-price');
        var vstock = parseInt(btn.getAttribute('data-cpdp-variant-stock') || '0', 10);
        var vavailable = btn.getAttribute('data-cpdp-variant-available') === 'true';

        if (sizeLabel) sizeLabel.textContent = vtitle;
        if (variantInput) variantInput.value = vid;
        if (root) root.setAttribute('data-cpdp-variant-id', vid);
        if (buyText) buyText.textContent = vavailable ? 'AÑADIR AL CARRITO' : 'AGOTADO';
        if (buyBtn) buyBtn.disabled = !vavailable;
        if (stickyPrice) stickyPrice.textContent = vprice;

        /* Barra fija y CTA emocional siguen el estado de la variante: antes
           decian AÑADIR siempre, aunque la ficha marcara agotado. */
        var stickyBuyBtn = document.getElementById('cpdpStickyBuy');
        if (stickyBuyBtn) {
          stickyBuyBtn.disabled = !vavailable;
          stickyBuyBtn.textContent = vavailable ? 'AÑADIR' : 'AGOTADO';
        }
        var emoBtn = document.getElementById('cpdpEmoCta');
        if (emoBtn && !emoBtn.classList.contains('is-added')) {
          emoBtn.disabled = !vavailable;
          emoBtn.textContent = vavailable ? (emoBtn.getAttribute('data-cpdp-cta-text') || 'AÑADIR AL CARRITO') : 'AGOTADO';
        }

        /* El precio PRINCIPAL tambien: antes solo se actualizaba el de la
           barra sticky, asi que con tallas de distinto precio la ficha
           mostraba uno y el carrito cobraba otro. */
        var mainPrice = document.getElementById('cpdpMainPrice');
        if (mainPrice && vprice) mainPrice.textContent = vprice;

        /* Marcar que el usuario YA eligio talla (lo usa el sticky para no
           anadir a ciegas una talla que nadie selecciono). */
        if (root) root.setAttribute('data-cpdp-size-chosen', 'true');

        var showStock = vavailable && vstock > 0 && vstock <= THRESHOLD;
        if (stockMobile) stockMobile.style.display = showStock ? '' : 'none';
        if (stockDesktop) stockDesktop.style.display = showStock ? '' : 'none';

        /* Ficha v2: precio dentro del boton, tachado y linea de stock */
        if (buyPrice && vprice) buyPrice.textContent = vprice;
        if (comparePrice) {
          var vcompare = btn.getAttribute('data-cpdp-variant-compare') || '';
          comparePrice.textContent = vcompare;
          comparePrice.hidden = !vcompare;
        }
        if (avail) {
          var st = !vavailable ? 'out' : (showStock ? 'low' : 'in');
          avail.setAttribute('data-state', st);
          var at = avail.querySelector('.cpv-avail__txt');
          var txt = avail.getAttribute('data-txt-' + st);
          if (at && txt) at.textContent = txt;
        }

        /* Galeria a la foto de la variante. -1 = la variante no tiene foto
           propia: se deja donde esta, mejor que mandar al comprador a la 1. */
        var mediaIdx = parseInt(btn.getAttribute('data-cpdp-variant-media') || '-1', 10);
        if (mediaIdx >= 0 && typeof galleryGoTo === 'function') galleryGoTo(mediaIdx);
      });
    });
  }

  /* ============================================================
     FICHA v2 (2026-10-25) — todo acotado a elementos de la v2: en
     celer-pdp-beta-fura (que comparte este JS) no existen y no hace nada.
     ============================================================ */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MQ_MOBILE = window.matchMedia('(max-width: 1023px)');

  /* Galeria v2: en movil, carrusel con puntos; en escritorio, fotos
     apiladas y la de la variante elegida pasa a ser la grande (is-lead). */
  function initGalleryV2() {
    var track = document.getElementById('cpdpV2Track');
    if (!track) return;
    var gal = document.getElementById('cpdpGallery');
    var tiles = Array.prototype.slice.call(track.querySelectorAll('.cpv-tile'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('#cpdpV2Dots .cpv-dot'));
    var count = tiles.length;
    if (!count) return;
    var current = parseInt((gal && gal.getAttribute('data-cpdp-start-media')) || '0', 10);
    if (!(current >= 0 && current < count)) current = 0;

    function setDot(i) {
      current = i;
      dots.forEach(function(d, k) {
        var on = k === i;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function slideLeft(i) {
      var el = tiles[i];
      return el ? el.offsetLeft - tiles[0].offsetLeft : 0;
    }
    function scrollToSlide(i, smooth) {
      i = Math.max(0, Math.min(count - 1, i));
      track.scrollTo({ left: slideLeft(i), behavior: (smooth && !REDUCED && !document.hidden) ? 'smooth' : 'auto' });
      setDot(i);
    }
    var LEAD_SIZES = '(min-width: 1024px) calc(100vw - 600px), 100vw';
    var REST_SIZES = '(min-width: 1024px) calc(50vw - 300px), 100vw';
    function setLead(i) {
      if (!tiles[i] || tiles[i].classList.contains('is-lead')) return;
      tiles.forEach(function(t, k) {
        var lead = k === i;
        t.classList.toggle('is-lead', lead);
        var im = t.querySelector('img');
        if (im) im.setAttribute('sizes', lead ? LEAD_SIZES : REST_SIZES);
        t.classList.remove('is-wide');
      });
      /* con un numero impar de fotos restantes, la ultima va a ancho
         completo para no dejar un hueco en la rejilla */
      var rest = tiles.filter(function(t) { return !t.classList.contains('is-lead'); });
      if (rest.length % 2 === 1 && rest.length > 1) rest[rest.length - 1].classList.add('is-wide');
      var lead = tiles[i];
      if (!REDUCED) {
        lead.classList.remove('is-swap');
        void lead.offsetWidth;
        lead.classList.add('is-swap');
      }
      var r = lead.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) {
        lead.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      }
      setDot(i);
    }
    function goTo(i) {
      if (MQ_MOBILE.matches) scrollToSlide(i, true);
      else setLead(i);
    }

    var ticking = false;
    track.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        ticking = false;
        if (!MQ_MOBILE.matches) return;
        var w = tiles[0].getBoundingClientRect().width || track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        i = Math.max(0, Math.min(count - 1, i));
        if (i !== current) setDot(i);
      });
    }, { passive: true });
    dots.forEach(function(d, k) { d.addEventListener('click', function() { scrollToSlide(k, true); }); });

    galleryGoTo = goTo;

    /* Arranque con ?variant=X: en movil se coloca el carrusel en su foto
       (offsetLeft real; en la carga el ancho aun puede ser 0). */
    var start = current;
    function applyStart() {
      if (!MQ_MOBILE.matches || start <= 0 || track.scrollLeft > 0) return;
      var left = slideLeft(start);
      if (left > 0) { track.scrollLeft = left; setDot(start); }
    }
    applyStart();
    requestAnimationFrame(applyStart);
    window.addEventListener('load', applyStart, { once: true });

    initZoom(track, function() { return current; }, function(i) {
      if (MQ_MOBILE.matches) scrollToSlide(i, false);
    }, count);
  }

  /* Acordeones v2: altura animada con grid 0fr -> 1fr (CSS) */
  function initAccordionV2() {
    document.querySelectorAll('.cpv-acc__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.cpv-acc__item');
        if (!item) return;
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Linea de envio gratis (EUR): se repinta tras cualquier cambio del carrito */
  var fmtEur = null;
  function formatEur(cents, fmt) {
    /* mismo formato que el filtro money de la tienda (p.ej. «€12,10») */
    if (fmt && fmt.indexOf('{{') > -1) {
      var n = (cents / 100).toFixed(2), parts = n.split('.');
      var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(m, key) {
        if (key === 'amount_with_comma_separator') return withDots + ',' + parts[1];
        if (key === 'amount_no_decimals_with_comma_separator') return withDots;
        if (key === 'amount_no_decimals') return withCommas;
        return withCommas + '.' + parts[1];
      });
    }
    try {
      if (!fmtEur) fmtEur = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: 'EUR' });
      return fmtEur.format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function paintShip(cart) {
    var perk = document.getElementById('cpdpShipPerk');
    if (!perk || !cart) return;
    var txt = perk.querySelector('[data-cpv-ship-text]');
    if (!txt) return;
    if (perk.getAttribute('data-eur') !== 'true' || (cart.currency && cart.currency !== 'EUR')) return;
    var thr = parseInt(perk.getAttribute('data-threshold') || '0', 10);
    var total = Number(cart.total_price) || 0;
    var out;
    if (!thr || !cart.item_count) out = perk.getAttribute('data-base') || txt.textContent;
    else if (total >= thr) out = 'Envío gratis incluido';
    else out = 'Faltan ' + formatEur(thr - total, perk.getAttribute('data-money-format')) + ' para envío gratis';
    perk.classList.toggle('is-free', !!(thr && cart.item_count && total >= thr));
    txt.textContent = out;
  }
  var shipTimer = null;
  function refreshShip() {
    if (!document.getElementById('cpdpShipPerk')) return;
    clearTimeout(shipTimer);
    shipTimer = setTimeout(function() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(paintShip)
        .catch(function() {});
    }, 350);
  }
  function initShipLine() {
    if (!document.getElementById('cpdpShipPerk')) return;
    document.addEventListener('cart:update', refreshShip);
    document.addEventListener('cart:refresh', refreshShip);
  }

  /* Completa tu equipo (columna): «+» anade sin salir; con tallas abre
     las pildoras de talla en la propia fila y no anade a ciegas. */
  function xsAdd(btn, variantId) {
    var row = btn.closest('[data-cpv-xs]');
    var msg = row && row.querySelector('[data-cpv-xs-msg]');
    if (msg) msg.textContent = '';
    btn.classList.add('is-loading');
    btn.disabled = true;
    var f = document.createElement('form');
    var a = document.createElement('input'); a.name = 'id'; a.value = String(variantId); f.appendChild(a);
    var q = document.createElement('input'); q.name = 'quantity'; q.value = '1'; f.appendChild(q);
    addToCart(f).then(function(data) {
      if (row) {
        row.classList.add('is-added');
        setTimeout(function() { row.classList.remove('is-added'); }, 2200);
      }
      dispatchCartUpdate(data);
      var after = (window.CelerCart && typeof window.CelerCart.refresh === 'function')
        ? Promise.resolve(window.CelerCart.refresh()).catch(function() {})
        : Promise.resolve();
      return after.then(function() {
        if (!openCartDrawer()) window.location.href = '/cart';
      });
    }).catch(function(err) {
      if (msg) msg.textContent = (err && (err.description || err.message)) || 'No se ha podido añadir. Inténtalo de nuevo.';
    }).then(function() {
      btn.classList.remove('is-loading');
      if (!btn.hasAttribute('aria-disabled')) btn.disabled = false;
    });
  }
  function closeXsSizes(except) {
    document.querySelectorAll('[data-cpv-xs-toggle][aria-expanded="true"]').forEach(function(t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = true;
      var r = t.closest('[data-cpv-xs]');
      if (r) r.classList.remove('is-picking');
    });
  }
  function initXsellInline() {
    var root = document.querySelector('[data-cpv-xs-root]');
    if (!root) return;
    root.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-cpv-xs-toggle]');
      if (toggle) {
        var panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel) return;
        var willOpen = panel.hidden;
        closeXsSizes(toggle);
        panel.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        var row = toggle.closest('[data-cpv-xs]');
        if (row) row.classList.toggle('is-picking', willOpen);
        if (willOpen) {
          var first = panel.querySelector('.cpv-xs__size:not([disabled])');
          if (first) first.focus({ preventScroll: true });
        }
        return;
      }
      var add = e.target.closest('[data-cpv-xs-variant]');
      if (add && !add.disabled) xsAdd(add, add.getAttribute('data-cpv-xs-variant'));
    });
    root.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      var open = root.querySelector('[data-cpv-xs-toggle][aria-expanded="true"]');
      if (!open) return;
      closeXsSizes();
      open.focus();
    });
  }

  /* Columna sticky inteligente (escritorio): bajo el header si cabe; si es
     mas alta que la pantalla, se pega por abajo (top negativo) para que se
     pueda leer entera sin scroll propio. */
  function initSmartSticky() {
    var col = document.querySelector('.cpdp-v2 .cpv-info');
    if (!col) return;
    var rootEl = col.closest('.cpdp-v2');
    function headerH() {
      var h = document.getElementById('header-group') || document.querySelector('.shopify-section-group-header-group');
      return h ? Math.round(h.getBoundingClientRect().height) : 80;
    }
    function apply() {
      if (MQ_MOBILE.matches) { rootEl.style.removeProperty('--cpv-top'); return; }
      var top = headerH() + 24;
      var free = window.innerHeight - top - 24;
      var hgt = col.offsetHeight;
      var t = hgt > free ? (window.innerHeight - hgt - 24) : top;
      rootEl.style.setProperty('--cpv-top', t + 'px');
    }
    apply();
    window.addEventListener('resize', apply, { passive: true });
    window.addEventListener('load', apply, { once: true });
    if ('ResizeObserver' in window) new ResizeObserver(apply).observe(col);
  }

  /* Fila de colores (movil: deslizable): la activa visible al cargar,
     moviendo solo el contenedor, nunca la pagina. */
  function initSwatchRow() {
    var row = document.querySelector('.cpdp-v2 .cpv-colors__row');
    if (!row) return;
    function center() {
      var a = row.querySelector('.cpv-swatch.is-active');
      if (!a || row.scrollWidth <= row.clientWidth) return;
      row.scrollLeft = Math.max(0, a.offsetLeft - (row.clientWidth - a.offsetWidth) / 2);
    }
    center();
    window.addEventListener('load', center, { once: true });
  }

  /* «4.8 ★» lleva a la seccion de opiniones de la plantilla */
  function initReviewsLink() {
    document.querySelectorAll('[data-cpv-to-reviews]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var target = document.querySelector('[id^="ch-rv-"]');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function boot() {
    initGalleryV2();
    initAccordionV2();
    initShipLine();
    initXsellInline();
    initSmartSticky();
    initSwatchRow();
    initReviewsLink();
    initGallery();
    initSizeSelector();
    initColorPrefetch();
    initAccordion();
    initFadeIn();
    initStickyVisibility();
    initAtc();
    initXsellAdd();
    initCarousels();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(boot, 0);
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
